import React from 'react';
import PictureEditor from '../../../../businessLogic/pictureEditor';

export default function CenterPanelUpdate(props) {
  return (
    <span>
      <div className="ui form">
        <div className="logoTitleColumn">
          <div>
            <div className="mrbxs" />
            <PictureEditor
              ref={(pictureCtrl) => {
                props.imageLogoRef(pictureCtrl);
              }}
              readOnly={props.readOnly}
              width={360}
              height={110}
              minimumScaleImage={0.2}
              pictureEditorClass={'waOrgLogoShell'}
              border={10}
              imageUrl={props.organisationalUnitLogoImageForm.orgLogoUrl}
              showAsDefaultImage={false}
              displayUploadOptions={false}
              color={[128, 128, 128, 0.7]}
            />
          </div>
          <div data-show={!props.readOnly} className="mrts center-text-on-small-ress centerAlignDescription">
            <label className="placeholder-label color-info-mid-grey-desktop   no-bold color-placeholder">
              {APP.LANGUAGE.DefaultOrgLogo.ScreenLabel1}
            </label>
          </div>
          <div data-show={!props.readOnly} className="mrtxxs center-text-on-small-ress centerAlignDescription">
            <label className="placeholder-label color-info-mid-grey-desktop  no-bold color-placeholder">
              {APP.LANGUAGE.DefaultOrgLogo.ScreenLabel2}
            </label>
          </div>
          <div data-show={!props.readOnly} className="mrtxxs  center-text-on-small-ress centerAlignDescription">
            <label className="placeholder-label color-info-mid-grey-desktop  no-bold color-placeholder">
              {APP.LANGUAGE.DefaultOrgLogo.ScreenLabel3}
            </label>
          </div>
          <div data-show={props.readOnly} className="mrtl  center-text-on-small-ress centerAlignDescription">
            <label className="placeholder-label color-info-mid-grey-desktop  no-bold color-placeholder">
              {APP.LANGUAGE.DefaultOrgLogo.Help}
            </label>
            <div className="mrbl hide-on-small-ress" />
          </div>

          <div className="mrbs" />
        </div>

        <div className="clear-both" />
      </div>
      <div className="mrbxxl pdbl hide-on-small-ress" />
    </span>
  );
}
